import React, { Component } from 'react';

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>Not found page</div>
        );
    }
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/notfound/index.js